$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
Backbone = require 'backbone'
Data = require '../data'
WorksList = require './works-list'
PreloadImage = require '../../components/preload-image'
Slider = require './slider'
{ find, template, size, defaults, merge } = require 'lodash'
{ addParam, getParams } = require './params'

module.exports =
class WorksDetail extends Singleton

  selector          : '.section-works'
  detailSelector    : '.lower-container'
  cntSelector       : '.project-container'
  cntInrSelector    : '.project-container-inner'
  loaderSelector    : '.loader'
  controllerSelector: '.controller'
  prevSelector      : '.prev'
  nextSelector      : '.next'
  templateSelector  : '.template-works-detail'
  sliderSlector     : '.slider'
  detailParams      : 'detail'

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded'    : @onPagesLoaded
        'worksJsonLoaded': @onWorksJsonLoaded
      .on
        'detailOpenBefore.works': @onDetailOpenBefore
        'detailCloseAfter.works': @onDetailCloseAfter

    @locationName = ''
    @locationId   = 0
    @hasPushState = window.history and history.pushState

  onPagesLoaded: =>
    @$section    = $ @selector
    @$detail     = @$section.find @detailSelector
    @$cnt        = @$detail.find @cntSelector
    @$cntInr     = @$detail.find @cntInrSelector
    @$loader     = @$detail.find @loaderSelector
    @$controller = @$detail.find @controllerSelector
    @$prev       = @$detail.find @prevSelector
      .on 'click', @prev
    @$next       = @$detail.find @nextSelector
      .on 'click', @next
    @$tmp        = @$section.find @templateSelector

    @tmp = template @$tmp.html()

    @slider = new Slider "#{@selector} #{@detailSelector}"

  onWorksJsonLoaded: =>
    @data    = WorksList.data
    @dataLen = size @data

  onDetailOpenBefore: (e, target) =>
    @goTo target

  onDetailCloseAfter: =>
    @$loader.css
      'display': 'block'
      'opacity': 1
    @$cnt.css 'display', 'none'
    @slider.end()
    @$cntInr.empty()

  prev: =>
    @move @data[@locationName].id - 1

  next: =>
    @move @data[@locationName].id + 1

  move: (id) ->
    for name, data of @data when data.id is id
      targetName = name
      break
    pathname =
      if @hasPushState
        location.pathname
      else
        '/works/'
    query = $.param merge(getParams(), { "#{@detailParams}": targetName })
    Backbone.history.navigate "#{pathname}?#{query}", true

  goTo: (target) =>
    addParam 4, @detailParams, target
    @$window.trigger 'detailOpend'

    @scaleAnime @$cnt, false,
      complete: =>
        @scaleAnime @$loader, true,
          complete: =>
            @create target

  create: (target) ->
    @loadData @data[target], target
    @locationName  = target
    @setLocationId = @data[target].id
    @toggleController @setLocationId

  loadData: (data, target) ->
    data.keyName = target
    @$cntInr
      .empty()
      .append @tmp data
    @slider.set()

    preloadImage = new PreloadImage "#{@selector} #{@cntSelector}"
    preloadImage
      .load()
      .then =>
        @scaleAnime @$loader, false,
          complete: =>
            @scaleAnime @$cnt, true,
              complete: =>
                @slider.start()

  scaleAnime: ($el, toggle, opts = {}) ->
    opts = defaults opts,
      duration: 500
      easing  : 'easeOutQuint'

    if toggle
      scale        = [1, 0]
      opts.display = 'block'
    else
      scale        = [0, 1]
      opts.display = 'none'

    $el
      .velocity 'stop'
      .velocity
        scale: scale
      , opts

  toggleController: (id) ->
    return if 1 >= @dataLen

    if 0 >= id
      @$prev.css 'display', 'none'
    else if @$prev.is ':hidden'
      @$prev.css 'display', 'block'

    if (@dataLen - 1) <= id
      @$next.css 'display', 'none'
    else if @$next.is ':hidden'
      @$next.css 'display', 'block'



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/works-detail.coffee